import { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useMedia } from 'react-use';
import { useRouter } from 'next/navigation';

export const useSearch = ({ searchValue, setSearchValue, closeAction }) => {
  const isTablet = useMedia('(min-width: 768px) and (max-width: 1023px)', true);
  const isDesktop = useMedia('(min-width: 1024px)', true);
  const router = useRouter();
  const [isLoadingSearchPage, setIsLoadingSearchPage] = useState(false)

  const { triggerRoute, serverSideRendering } = useSelector(
    (state) => ({
      triggerRoute: state['demo-common'].triggerRoute,
      serverSideRendering: state.renderContext.serverSideRendering,
    }),
    shallowEqual,
  );

  const setValueFromLocalStorage = (query) => {
    setSearchValue(query);
    if (window) {
      window.localStorage.setItem('searchedValue', query);
    }
  };

  const removeValueFromLocalStorage = () => {
    setSearchValue('');
    if (window) {
      window.localStorage.removeItem('searchedValue');
    }
  };

  const gotToSearchPage = (value) => {
    const phrase = (typeof value === 'string' && value) || searchValue.trim();
    if (!phrase) return;
    setIsLoadingSearchPage(true);
    closeAction && closeAction();
    const encodedPhrase = phrase.replace(/ /g, '+');
    removeValueFromLocalStorage();
    router.push(`/q/${encodedPhrase}`, { phrase: encodedPhrase });

    closeAction && closeAction();
  };

  const getPositionToTop = () => {
    const stickyHeaderBounding = (typeof document !== 'undefined' &&
      document.getElementById('stickyHeader')?.getBoundingClientRect()) || {
      bottom: 0,
    };
    return stickyHeaderBounding.bottom;
  };

  useEffect(() => {
    removeValueFromLocalStorage();
    setIsLoadingSearchPage(false)
  }, [triggerRoute]);

  useEffect(() => {
    if (!serverSideRendering) {
    }
  }, [serverSideRendering]);

  return {
    searchValue,
    isTablet,
    isDesktop,
    isLoadingSearchPage,
    gotToSearchPage,
    getPositionToTop,
  };
};
